
import { goodsBelongLabels, goodsState } from 'json/mall-options'
export let filterLabels = [
  {
    label: '归属',
    value: 'goodsBelong',
    clearable: true,
    type: 'select',
    options: goodsBelongLabels
  },
  {
    label: '类型',
    type: 'select',
    clearable: true,
    value: 'type', // 需返回数据的字段名
    options: [],
    props: {
      label: 'name',
      value: 'value'
    }
  },
  {
    label: '分组',
    type: 'select',
    clearable: true,
    value: 'groupId', // 需返回数据的字段名
    options: [],
    props: {
      label: 'name',
      value: 'id'
    }
  },
  {
    label: '状态',
    type: 'select',
    value: 'state',
    clearable: true,
    options: goodsState
  },
  {
    label: '所需积分',
    clearable: true,
    type: 'number-slot',
    minName: 'priceIntervalMin',
    maxName: 'priceIntervalMax',
    value: 'priceInterval'
  },
  {
    label: '发布时间',
    clearable: true,
    startName: 'createdDateStart',
    endName: 'createdDateEnd',
    type: 'time-slot',
    value: 'publishTime'
  },
  {
    label: '第三方供应商',
    type: 'select',
    value: 'vendorId',
    props: { label: 'name', value: 'id' },
    clearable: true,
    options: []
  }
]
export let goodsTableLabel = [
  {
    label: '地区',
    value: 'address'
  },
  {
    label: '类型',
    value: 'goodsDTO.goodsData.typeName'
  },
  {
    label: '上架时间',
    minWidth: 100,
    value: 'putOnSaleTime'
  }
]
// 待审核状态展示时间字段
export let WAITING_FOR_APPROVAL = [{
  label: '创建时间',
  value: ''
}]
// 已上架状态展示时间字段
export let PUBLISHED = [
  {
    label: '上架时间',
    minWidth: 100,
    value: 'putOnSaleTime'
  }]
// 已下架状态展示时间字段
export let OFF_SHELVES = [
  {
    label: '下架时间',
    value: ''
  }]
export let goodsTableLabelOfView = [
  {
    label: '地区',
    value: 'address'
  },
  {
    label: '类型',
    value: 'goodsDTO.goodsData.typeName'
  },
  {
    label: '推荐值',
    value: 'goodsOtherInfoDTO.ranking'
  },
  {
    label: '是否在商城展示',
    value: 'mall_visible'
  },
  {
    label: '首页展示',
    value: 'recommend'
  },
  {
    label: '置顶',
    value: 'sticky'
  }
]
export let pageStutesTabs = [
  {
    label: '待审核',
    value: 'WAITING_FOR_APPROVAL'
  },
  {
    label: '已发布',
    value: 'PUBLISHED'
  },
  {
    label: '已下架',
    value: 'OFF_SHELVES'
  }
]
